import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const GridView = createSvgIcon(
  <path d="M10.5 0H0v10.5h10.5V0ZM2.25 8.25v-6h6v6h-6ZM24 0H13.5v10.5H24V0Zm-8.25 8.25v-6h6v6h-6ZM0 13.5h10.5V24H0V13.5Zm2.25 2.25v6h6v-6h-6ZM24 13.5H13.5V24H24V13.5Zm-8.25 8.25v-6h6v6h-6Z" />,
  'GridView'
);

export { GridView };